import React from "react";

function CardInfo({ imagen, titulo, descripcion }) {
  return (
    <div className="flex flex-col items-center bg-blanco p-6 pt-12 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 w-80 mx-4 my-1 gap-4 border-2 border-transparent hover:border-oro group relative overflow-hidden">
      
      {/* Fondo con gradiente en hover */}
      <div className="absolute inset-0 bg-gradient-to-b from-oro/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

      {/* Imagen en columna con padding */}
      <div className="relative w-24 h-24 bg-blanco rounded-full shadow-xl border-4 border-oro flex items-center justify-center z-10">
        <img 
          src={imagen} 
          alt={titulo} 
          className="w-20 h-20 object-contain rounded-full transition-transform duration-300 group-hover:scale-110"
        />
      </div>

      {/* Contenido */}
      <h2 className=" text-azul-oscuro text-2xl font-bold ">
        {titulo}
      </h2>

      <div className="relative h-1 w-16 bg-oro rounded-full opacity-90 z-10"></div>

      <p className="relative text-gris-oscuro text-base text-justify leading-relaxed text-center z-10 whitespace-pre-line">
        {descripcion}
      </p>
      
    
      <div className="absolute bottom-0 left-0 right-0 h-2 bg-gradient-to-r from-oro/40 to-azul-oscuro/20"></div>
    </div>
  );
}

export default CardInfo;
